import { Component, importProvidersFrom } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { RouterModule } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './services/auth.service';
import { CommonModule } from '@angular/common';
import { environment } from '../environments/environment';
import { HeaderMiniComponent } from './component/header-mini/header-mini.component';
import { registerLocaleData } from '@angular/common';
import localeIT from "@angular/common/locales/it";
import { from, Observable, Subject } from 'rxjs';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  standalone: true,
  providers: [
    ],
  imports: [RouterOutlet, RouterModule, CommonModule, HeaderMiniComponent, NgxSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = environment.siteTitle;
  baseUrl = environment.baseUrl;

  authService: AuthService ;

  showHeader = true;
  public headerStatusObservable = new Subject<boolean>();
  spinnerType: string = 'ball-fussion';

  constructor(private readonly _router: Router, private spinnerService: NgxSpinnerService ) {
    this.authService = inject(AuthService);
    console.log('production: ' + environment.production); // Logs false for development environment

    registerLocaleData(localeIT, "it");

    this._router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.modifyHeader(e);
      }
    });
  }
  modifyHeader(location:any) { // This method is called many times
    if (location.url.startsWith('/stampabadges') ||
      location.url.startsWith('/presenza') ||
      location.url.startsWith('/presenze')) {
      //console.log(location.url); // This prints a loot of routes on console
      this.showHeader = false;
    } else {
      this.showHeader = true;
    }
    this.headerStatusObservable.next(this.showHeader);
  }

  public showSpinner(_timeout: boolean = false): void {
    this.spinnerService.show();

    if (_timeout) {
      setTimeout(() => {
        this.spinnerService.hide();
      }, 3000); // 3 seconds
    }
  }
  public hideSpinner(_timeout: boolean = false): void {
    this.spinnerService.hide();
  }
  logOut() {
    this.authService.logout();
    this._router.navigate(['/login']);
  }
}
